import React, { useEffect, useState } from "react";
import {
  Card,
  Checkbox,
  Col,
  Flex,
  List,
  message,
  Row,
  Form,
  Typography,
  Input,
  Menu,
  Dropdown,
  Select,
  Divider,
  Segmented,
} from "antd";
import {
  CustomButton,
  CustomDynamicSelect,
  CustomModalWithoutButton,
  CustomParagraph,
  CustomSelect,
  CustomTitle,
} from "../../components";
import ReactApexChart from "react-apexcharts";
import ChevronRightGray from "../../assets/images/chevron-right-gray.svg";
import {
  GetShipmentChart,
  GetOntimeChart,
  GetAverageTimeChart,
  GetRightTimeChart,
  GetNewsFlash,
} from "../../api's/homeAPI";
import {
  CheckOutlined,
  DownOutlined,
  LeftOutlined,
  RightOutlined,
} from "@ant-design/icons";
import { DatePicker } from "antd";
import dayjs from "dayjs";
import { GoogleMapsProvider } from "../../components/GoogleMapsProvider";
import { useMemo } from "react";

import "leaflet/dist/leaflet.css";
import L from "leaflet";
import OsmMap from "../../components/OsmMap";
import AnalyticsCard from "./partials/AnalyticsCard";
import AnalyticsData from "./partials/AnalyticsData";
import CustomModalWithoutButtons from "../../components/CustomModalWithoutButtons";
import HomeGoolgeMap from "./HomeGoogleMap";
import { GetHomeLocations, GetUserTask } from "../../api's/homeAPI";
import { useSpin } from "../../components/SpinContext";
import { useToken } from "../../common/helper";
import { Link, useNavigate } from "react-router-dom";
import { selectCouriersState } from "../../reudx-toolkit/slice/onboardingSlice";
import { useDispatch, useSelector } from "react-redux";
import {
  getCompanyCouriersDDL,
  getLocationDDL,
  getTeamsDDL,
  getTeamsDDLOFFeature,
} from "../../common/utils/dropDown";
import { getPermissions } from "../../common/helper/getPermissions";
import { getSettingsCouriersDDL } from "../../common/utils/dropDown";
import { CustomizeFilterCalendar } from "../../components";
import HomeDateFilter from "../../components/HomeDateFilter";
import MetricsForm from "./partials/MetricsForm";
import HomeFilterDropdown from "./partials/HomeFilterDropdown";
import { fetchAllProducts } from "../../reudx-toolkit/slice/ProductSlice";
import NewsFlash from "./partials/NewsFlash";
import { GetShipments } from "../../api's/shipment";
import moment from "moment/moment";
import AnalyticsChartData from "./partials/AnalyticsChartData";
import ModifyBuffer from "./partials/ModifyBuffer";

function Home() {
  const state = useSelector((state) => state);
  const dispatch = useDispatch();
  const [visibleDateFilter, setVisibleDateFilter] = useState(false);
  const [initialDateModal, setInitialDateModal] = useState({
    start_date: dayjs().subtract("29", "day").format("MM/DD/YYYY"),
    end_date: dayjs().format("MM/DD/YYYY"),
    period: "Last 30 days",
  });
  const [selectedDateFilter, setSelectedDateFilter] = useState(null);
  // const mainMenu = useSelector((state) => state.menu.items);
  // const homePermissions = mainMenu?.find((item)=>item?.name.toLowerCase()=='home')
  // console.log('home : ' , homePermissions)
  // console.log('initialDateModal' , initialDateModal)
  // useEffect(() => {
  //   if (!homePermissions?.permissions?.is_view) {
  //     navigate(-1);
  //   }
  // }, [])

  //teams for drop down
  const teamsList = useSelector((state) => state.teams.list);

  const hasValidTeams = !(
    teamsList.length === 0 ||
    (teamsList.length === 1 && teamsList[0].name.toLowerCase() === "default")
  );

  // console.log("main menu from server/store", menuItems);
  const [form] = Form.useForm();
  const { showSpin, hideSpin } = useSpin();
  const { token, removeToken, decodedUserToken } = useToken();
  let decodedToken = decodedUserToken();

  const [shipmentChart, setShipmentChart] = useState({
    categories: [],
    data: [],
  });
  const [ontimeChart, setOntimeChart] = useState({
    categories: [],
    data: [],
  });
  const [averagetimeChart, setAveragetimeChartt] = useState({
    categories: [],
    average_transit_times: [],
  });
  const [rightTimeChart, setRightTimeChart] = useState({
    categories: [],
    data: [],
  });

  const navigate = useNavigate();
  const getDefaultDate = () => {
    return "2025-01-01"; // Fixed date in YYYY-MM-DD format
  };

  const [selectedDate, setSelectedDate] = useState({
    start_date: getDefaultDate(),
    locations: [],
    transporters: [],
  });

  const [modalOpen, setModalOpen] = useState(false);
  const [selectedMetircData, setSelectedMetricData] = useState({});
  const closeModal = () => {
    setModalOpen(false);
  };
  const onScuccessTarget = () => {
    setModalOpen(false);
    fetchShipmentChart();
    fetchOntimeChart();
    fetchAverageTimetChart();
    fetchRightTimeChart();
  };
  
  // for buffer modal 
  const [openBufferModal, setOpenBufferModal] = useState(false);
  const closeBufferModal = () => {
    setOpenBufferModal(false);
  };
  const onScuccessSetBuffer = () => {
    setOpenBufferModal(false);
    fetchOntimeChart();
  };

  // const handleItemClick = (index) => {
  //   const updatedTasks = [...tasksData];
  //   updatedTasks[index].checked = !updatedTasks[index].checked;
  //   setTasks(updatedTasks);
  // };

  const colorMap = {
    // status 
    'Delivered': shipmentChart?.chart_type == 'status'  ?  "#009A51" : '#1292E8',//d
    "Delivery exception": "#ED6E33", //d
    "In transit": "#266EF1", //d
    "Awaiting pick up": "#8F8F8F", //d
    'Pending': "#FFC043", //d
    "Not found": "#DE1135", //d
// Timeliness 
    "On time": "#0CBDBA", //d
    'Early': "#FFEB3B", //d
    'Late': "#FA4E56", //d
    'Other': "#8F8F8F", //d
// Risk 
    "No issue": "#1292E8", //d
    "At-risk alert": "#F6BC2F",//d
    "Critical alert": "#DE1135",//d
  };
  
  // const colors = shipmentChart?.series?.map((s) => colorMap[s?.name] || "#1292E8");

  const colors = shipmentChart?.series?.map((s) => {
    const baseColor = colorMap[s?.name] || "#1292E8";
    const hasData = s?.data?.some((val) => val > 0);
    return hasData ? baseColor : hexToRGBA(baseColor, 0.3);
  });  
  
  function hexToRGBA(hex, alpha) {
    const r = parseInt(hex.slice(1, 3), 16);
    const g = parseInt(hex.slice(3, 5), 16);
    const b = parseInt(hex.slice(5, 7), 16);
    return `rgba(${r}, ${g}, ${b}, ${alpha})`;
  }
  
  
  const shipment = useMemo(
    () => ({
      options: {
        chart: {
          type: "bar",
          stacked: true, // 🔑 This enables the stacked bars
          width: "100%", // ✅ Ensure full width
          toolbar: {
            show: false,
          },
          animations: {
            enabled: false, // 🔥 Disable animations completely
          },         
          
        },
        legend: {
          show: true,
          position: 'bottom',
          fontSize: '10px',
          formatter: function (seriesName, opts) {
            const data = shipmentChart?.series?.[opts.seriesIndex]?.data || [];
            const hasData = data.some(val => val > 0);
            const color = hasData ? '#000' : '#b3b3b3';
            // const opacity = hasData ? 1 : 0.6;
        
            return `<span style="color: ${color}; ">${seriesName}</span>`;
          },
        },
        
        

        annotations: {
          yaxis: shipmentChart?.target_value
            ? [
                {
                  y: shipmentChart.target_value,
                  borderColor: "#AFAFAF",
                  borderWidth: 2,
                  strokeDashArray: 4,
                  // label: {
                  //   borderColor: "#AFAFAF",
                  //   style: {
                  //     color: "#fff",
                  //     background: "#afafaf",
                  //   },
                  //   text: `Target metric on ${shipmentChart.target_value}`,
                  // },
                },
              ]
            : [],
        },

        plotOptions: {
          bar: {
            columnWidth: "30%",
            borderRadius: 0,
          },
        },
        // colors: ["#2979FF"],
        colors,
        dataLabels: {
          enabled: false,
        },
        xaxis: {
          categories: shipmentChart?.categories || [], // ✅ Prevent undefined error
          labels: {
            style: {
              fontSize: "12px",
              colors: "#9E9E9E",
            },
          },
        },
        yaxis: {
          labels: {
            style: {
              fontSize: "12px",
              colors: "#9E9E9E",
            },
          },
          tickAmount: 3,
        },
        grid: {
          borderColor: "#E0E0E0",
        },
        responsive: [
          {
            breakpoint: 1600, // Large screens
            options: {
              plotOptions: {
                bar: {
                  columnWidth: "25%",
                },
              },
              xaxis: {
                labels: {
                  style: {
                    fontSize: "14px",
                  },
                },
              },
              yaxis: {
                labels: {
                  style: {
                    fontSize: "14px",
                  },
                },
              },
            },
          },
          {
            breakpoint: 1200, // Medium screens
            options: {
              plotOptions: {
                bar: {
                  columnWidth: "35%",
                },
              },
              xaxis: {
                labels: {
                  style: {
                    fontSize: "12px",
                  },
                },
              },
              yaxis: {
                labels: {
                  style: {
                    fontSize: "12px",
                  },
                },
              },
            },
          },
          {
            breakpoint: 768, // Small screens (tablets)
            options: {
              plotOptions: {
                bar: {
                  columnWidth: "100%",
                },
              },
              xaxis: {
                labels: {
                  style: {
                    fontSize: "10px",
                  },
                },
              },
              yaxis: {
                labels: {
                  style: {
                    fontSize: "10px",
                  },
                },
              },
            },
          },
          {
            breakpoint: 450, // Extra small screens (mobile)
            options: {
              plotOptions: {
                bar: {
                  columnWidth: "100%",
                },
              },
              xaxis: {
                labels: {
                  style: {
                    fontSize: "8px",
                  },
                },
              },
              yaxis: {
                labels: {
                  style: {
                    fontSize: "8px",
                  },
                },
              },
            },
          },
        ],
      },
      series: shipmentChart?.series || [], // ✅ Prevent undefined error
      // [
      //   {
      //     name: "Shipments",
      //     data: shipmentChart?.series || [], // ✅ Prevent undefined error
      //   },
      // ],
    }),
    [shipmentChart]
  );

  const onTimeDelivery = useMemo(
    () => ({
      options: {
        chart: {
          type: "bar",
          width: "100%",
          toolbar: {
            show: false,
          },
        },

        annotations: {
          yaxis: ontimeChart?.target_value
            ? [
                {
                  y: ontimeChart.target_value,
                  borderColor: "#AFAFAF",
                  borderWidth: 2,
                  strokeDashArray: 4,
                },
              ]
            : [],
        },

        plotOptions: {
          bar: {
            columnWidth: "30%",
            borderRadius: 0, // ✅ same rounded corners
          },
        },

        // colors: ["#2979FF"],
        colors: ["#0CBDBA"],

        dataLabels: {
          enabled: false,
        },

        xaxis: {
          categories: ontimeChart?.categories || [],
          labels: {
            style: {
              fontSize: "12px",
              colors: "#9E9E9E",
            },
          },
        },

        yaxis: {
          labels: {
            style: {
              fontSize: "12px",
              colors: "#9E9E9E",
            },
          },
          tickAmount: 3,
        },

        grid: {
          borderColor: "#E0E0E0",
        },

        responsive: [
          {
            breakpoint: 1600,
            options: {
              plotOptions: {
                bar: {
                  columnWidth: "25%",
                },
              },
              xaxis: {
                labels: {
                  style: {
                    fontSize: "14px",
                  },
                },
              },
              yaxis: {
                labels: {
                  style: {
                    fontSize: "14px",
                  },
                },
              },
            },
          },
          {
            breakpoint: 1200,
            options: {
              plotOptions: {
                bar: {
                  columnWidth: "35%",
                },
              },
              xaxis: {
                labels: {
                  style: {
                    fontSize: "12px",
                  },
                },
              },
              yaxis: {
                labels: {
                  style: {
                    fontSize: "12px",
                  },
                },
              },
            },
          },
          {
            breakpoint: 768,
            options: {
              plotOptions: {
                bar: {
                  columnWidth: "100%",
                },
              },
              xaxis: {
                labels: {
                  style: {
                    fontSize: "10px",
                  },
                },
              },
              yaxis: {
                labels: {
                  style: {
                    fontSize: "10px",
                  },
                },
              },
            },
          },
          {
            breakpoint: 450,
            options: {
              plotOptions: {
                bar: {
                  columnWidth: "100%",
                },
              },
              xaxis: {
                labels: {
                  style: {
                    fontSize: "8px",
                  },
                },
              },
              yaxis: {
                labels: {
                  style: {
                    fontSize: "8px",
                  },
                },
              },
            },
          },
        ],
      },

      series: [
        {
          name: "Performance",
          data: ontimeChart?.data || [],
        },
      ],
    }),
    [ontimeChart]
  );

  const avgTransitTime = useMemo(
    () => ({
      options: {
        chart: {
          type: "bar",
          width: "100%",
          toolbar: {
            show: false,
          },
        },

        annotations: {
          yaxis: averagetimeChart?.target_value
            ? [
                {
                  y: averagetimeChart.target_value,
                  borderColor: "#AFAFAF",
                  borderWidth: 2,
                  strokeDashArray: 4,
                },
              ]
            : [],
        },

        plotOptions: {
          bar: {
            columnWidth: "30%",
            borderRadius: 0, // ✅ Match shipment chart
          },
        },

        colors: ["#FFC914"],

        dataLabels: {
          enabled: false,
        },

        xaxis: {
          categories: averagetimeChart?.categories || [],
          labels: {
            style: {
              fontSize: "12px",
              colors: "#9E9E9E",
            },
          },
        },

        yaxis: {
          labels: {
            style: {
              fontSize: "12px",
              colors: "#9E9E9E",
            },
          },
          tickAmount: 3,
        },

        grid: {
          borderColor: "#E0E0E0",
        },

        tooltip: {
          y: {
            formatter: (value) => `${value} hr`,
          },
        },

        responsive: [
          {
            breakpoint: 1600,
            options: {
              plotOptions: {
                bar: {
                  columnWidth: "25%",
                },
              },
              xaxis: {
                labels: {
                  style: {
                    fontSize: "14px",
                  },
                },
              },
              yaxis: {
                labels: {
                  style: {
                    fontSize: "14px",
                  },
                },
              },
            },
          },
          {
            breakpoint: 1200,
            options: {
              plotOptions: {
                bar: {
                  columnWidth: "35%",
                },
              },
              xaxis: {
                labels: {
                  style: {
                    fontSize: "12px",
                  },
                },
              },
              yaxis: {
                labels: {
                  style: {
                    fontSize: "12px",
                  },
                },
              },
            },
          },
          {
            breakpoint: 768,
            options: {
              plotOptions: {
                bar: {
                  columnWidth: "100%",
                },
              },
              xaxis: {
                labels: {
                  style: {
                    fontSize: "10px",
                  },
                },
              },
              yaxis: {
                labels: {
                  style: {
                    fontSize: "10px",
                  },
                },
              },
            },
          },
          {
            breakpoint: 450,
            options: {
              plotOptions: {
                bar: {
                  columnWidth: "100%",
                },
              },
              xaxis: {
                labels: {
                  style: {
                    fontSize: "8px",
                  },
                },
              },
              yaxis: {
                labels: {
                  style: {
                    fontSize: "8px",
                  },
                },
              },
            },
          },
        ],
      },

      series: [
        {
          name: "Transit Time",
          data: averagetimeChart?.average_transit_times || [],
        },
      ],
    }),
    [averagetimeChart]
  );

  const atRiskAlerts = useMemo(
    () => ({
      options: {
        chart: {
          type: "bar",
          width: "100%",
          toolbar: {
            show: false,
          },
        },

        annotations: {
          yaxis: rightTimeChart?.target_value
            ? [
                {
                  y: rightTimeChart.target_value,
                  borderColor: "#AFAFAF",
                  borderWidth: 2,
                  strokeDashArray: 4,
                },
              ]
            : [],
        },

        plotOptions: {
          bar: {
            columnWidth: "30%",
            borderRadius: 0,
          },
        },

        colors: ["#FA4E56"],

        dataLabels: {
          enabled: false,
        },

        xaxis: {
          categories: rightTimeChart?.categories || [],
          labels: {
            style: {
              fontSize: "12px",
              colors: "#9E9E9E",
            },
          },
        },

        yaxis: {
          labels: {
            style: {
              fontSize: "12px",
              colors: "#9E9E9E",
            },
          },
          tickAmount: 3,
        },

        grid: {
          borderColor: "#E0E0E0",
        },

        tooltip: {
          y: {
            formatter: (value) => `${value}%`,
          },
        },

        responsive: [
          {
            breakpoint: 1600,
            options: {
              plotOptions: {
                bar: {
                  columnWidth: "25%",
                },
              },
              xaxis: {
                labels: {
                  style: {
                    fontSize: "14px",
                  },
                },
              },
              yaxis: {
                labels: {
                  style: {
                    fontSize: "14px",
                  },
                },
              },
            },
          },
          {
            breakpoint: 1200,
            options: {
              plotOptions: {
                bar: {
                  columnWidth: "35%",
                },
              },
              xaxis: {
                labels: {
                  style: {
                    fontSize: "12px",
                  },
                },
              },
              yaxis: {
                labels: {
                  style: {
                    fontSize: "12px",
                  },
                },
              },
            },
          },
          {
            breakpoint: 768,
            options: {
              plotOptions: {
                bar: {
                  columnWidth: "100%",
                },
              },
              xaxis: {
                labels: {
                  style: {
                    fontSize: "10px",
                  },
                },
              },
              yaxis: {
                labels: {
                  style: {
                    fontSize: "10px",
                  },
                },
              },
            },
          },
          {
            breakpoint: 450,
            options: {
              plotOptions: {
                bar: {
                  columnWidth: "100%",
                },
              },
              xaxis: {
                labels: {
                  style: {
                    fontSize: "8px",
                  },
                },
              },
              yaxis: {
                labels: {
                  style: {
                    fontSize: "8px",
                  },
                },
              },
            },
          },
        ],
      },

      series: [
        {
          name: "Right First Time",
          data: rightTimeChart?.data || [],
        },
      ],
    }),
    [rightTimeChart]
  );

  const unauthorize = (error) => {
    if (error && error?.status === 401) {
      removeToken();
      navigate("/login");
    }
  };

  // get user remaining taks
  const fetchUserTask = () => {
    // showSpin();
    GetUserTask(token)
      .then((res) => {
        const data = res?.data ? res.data : null;
        if (data) {
          if (data?.data?.is_success) {
            let resp = data?.data?.data ? data?.data?.data : [];
            if (resp) {
              setUserTask(resp);
            }
          } else {
            message.error(data?.data?.message);
          }
        }
      })
      .catch((error) => {
        unauthorize(error);
      })
      .finally(() => {
        hideSpin();
      });
  };

  // ============ FILTERS QUERY AND FETCH CALL FOR CHARTS ===================

  const [filterQuery, setFilterQuery] = useState(null);

  // console.log("filter query  :", filterQuery);

  const fetchShipmentChart = () => {
    const model = filterQuery;
    GetShipmentChart(token, model)
      .then((res) => {
        // console.log("Shipment Chart Response:", res);
        const data = res?.data ? res.data?.data : null;
        if (data) {
          if (data?.is_success) {
            const shipmentData = data?.data ? data.data : [];
            // console.log("Processed Shipment Data:", shipmentData);
            if (shipmentData) {
              setShipmentChart(shipmentData);
            }
          } else {
            message.error(data?.message);
          }
        }
      })
      .catch((error) => {
        console.error("Shipment Chart Error:", error);
        unauthorize(error);
      })
      .finally(() => {
        hideSpin();
      });
  };

  const fetchRightTimeChart = () => {
    // showSpin();
    const model = filterQuery;
    GetRightTimeChart(token, model)
      .then((res) => {
        const data = res?.data ? res.data?.data : null;
        if (data) {
          if (data?.is_success) {
            const rightTimeData = data?.data ? data.data : [];
            if (rightTimeData) {
              setRightTimeChart(rightTimeData);
            }
          } else {
            message.error(data?.message);
          }
        }
      })
      .catch((error) => {
        unauthorize(error);
      })
      .finally(() => {
        hideSpin();
      });
  };

  // fething average time chart data [mahtab]
  const fetchAverageTimetChart = () => {
    const model = filterQuery;
    GetAverageTimeChart(token, model)
      .then((res) => {
        const data = res?.data ? res.data?.data : null;
        if (data) {
          if (data?.is_success) {
            const AveragetimeData = data?.data ? data.data : [];
            if (AveragetimeData) {
              setAveragetimeChartt(AveragetimeData);
            }
          } else {
            message.error(data?.message);
          }
        }
      })
      .catch((error) => {
        unauthorize(error);
      })
      .finally(() => {
        hideSpin();
      });
  };

  const fetchOntimeChart = () => {
    const model = filterQuery;
    GetOntimeChart(token, model)
      .then((res) => {
        // console.log("Ontime Chart Raw Response:", res);
        const data = res?.data ? res.data?.data : null;
        // console.log("Ontime Chart Processed Data:", data);
        if (data) {
          if (data?.is_success) {
            const ontimeData = data ? data?.data : [];
            // console.log("Final Ontime Data:", ontimeData);
            if (ontimeData) {
              setOntimeChart(ontimeData);
            }
          } else {
            message.error(data?.message);
          }
        }
      })
      .catch((error) => {
        unauthorize(error);
      })
      .finally(() => {
        hideSpin();
      });
  };

  const handleDateChange = (dateString) => {
    setSelectedDate((prevState) => {
      if (dateString) {
        return {
          ...prevState,
          start_date:
            dateString?.$y + "-" + dateString?.$M + 1 + "-" + dateString?.$D,
        };
      }
      return prevState;
    });
  };

  const handleChartClickFilter =()=>{

  }





  useEffect(() => {
    fetchUserTask();
  }, []);
  const [timeRange, setTimeRange] = useState("week");

  useEffect(() => {
    let val = filterDateFormatter(initialDateModal);
    setSelectedDateFilter(val);
    let start = initialDateModal?.start_date
      ? dayjs(initialDateModal.start_date).format("YYYY-MM-DD")
      : null;
    let end = initialDateModal?.end_date
      ? dayjs(initialDateModal.end_date).format("YYYY-MM-DD")
      : null;
    setFilterQuery({
      start_date: start,
      end_date: end,
      origins: [],
      destinations: [],
      products: [],
      teams: [],
      transporters: [],
      period: initialDateModal.period,
      segment: timeRange,
      chart_type:'delivered',
      transit_time_filter: 'median',
      rft_alerts: [],
    });
  }, []);

  useEffect(() => {
    if (filterQuery) {
      fetchShipmentChart();
      fetchOntimeChart();
      fetchAverageTimetChart();
      fetchRightTimeChart();
    }
  }, [filterQuery]);
  // }, [selectedDate]);

  const [userTask, setUserTask] = useState({});
  const allTaskTrue = Object.values(userTask).every((value) => value === true);

  const main_menu = useSelector((state) => state.menu.items);
  const settings_sub_menu = main_menu?.find(
    (item) => item?.name === "Settings"
  );

  // console.log('settings submenu  : ' , settings_sub_menu)

  const tasksData = [
    {
      id: 0,
      title: "Connect your transport providers",
      description:
        "Sync your shipment data to ZoomLogi from your transport providers",
      checked: userTask?.has_courier,
      url: "/settings/couriers",
      // disable: decodedToken?.role?.toLowerCase() === "viewer" ? true : false,
      is_view: settings_sub_menu?.sub_menus
        ? settings_sub_menu?.sub_menus?.find(
            (item) => item?.name === "Transport providers"
          )?.permissions?.is_view
        : false,
    },
    {
      id: 1,
      title: "Add product info",
      description:
        "Tell us your product specifications so we know when to alert you of temperature excursions and viability risks",
      checked: userTask?.has_product,
      url: "/settings/product",
      // disable: decodedToken?.role?.toLowerCase() === "viewer" ? true : false,
      is_view: settings_sub_menu?.sub_menus
        ? settings_sub_menu?.sub_menus?.find(
            (item) => item?.name === "Products"
          )?.permissions?.is_view
        : false,
    },
    {
      id: 2,
      title: "Connect your sensors",
      description:
        "Allow ZoomLogi to read your sensor data to help monitor your shipments",
      checked: userTask?.has_sensor,
      url: "/settings/sensor",
      // disable: decodedToken?.role?.toLowerCase() === "viewer" ? true : false,
      is_view: settings_sub_menu?.sub_menus
        ? settings_sub_menu?.sub_menus?.find((item) => item?.name === "Sensors")
            ?.permissions?.is_view
        : false,
    },
    {
      id: 3,
      title: "Add location info",
      description: "Complete your shipping location profiles",
      checked: userTask?.has_location,
      url: "/settings/location",
      // disable: decodedToken?.role?.toLowerCase() === "viewer" ? true : false,
      is_view: settings_sub_menu?.sub_menus
        ? settings_sub_menu?.sub_menus?.find(
            (item) => item?.name === "Locations"
          )?.permissions?.is_view
        : false,
    },
    {
      id: 4,
      title: "Set your notification preferences",
      description:
        "Tell us when and how you'd like to be notified of shipment alerts",
      checked: userTask?.has_notification,
      url: "/settings/notification",
      // disable: false,
      is_view: settings_sub_menu?.sub_menus
        ? settings_sub_menu?.sub_menus?.find(
            (item) => item?.name === "Notifications"
          )?.permissions?.is_view
        : false,
    },
  ];

  // console.log('Task data : ' , tasksData)

  const couriersPermissions = settings_sub_menu?.sub_menus
    ? settings_sub_menu?.sub_menus?.find(
        (item) => item?.name === "Transport providers"
      )?.permissions?.is_view
    : false;

  const locationPermissions = settings_sub_menu?.sub_menus
    ? settings_sub_menu?.sub_menus?.find((item) => item?.name === "Locations")
        ?.permissions?.is_view
    : false;

  const productsPermissions = settings_sub_menu?.sub_menus
    ? settings_sub_menu?.sub_menus?.find((item) => item?.name === "Products")
        ?.permissions?.is_view
    : false;

  const teamsPermissions = settings_sub_menu?.sub_menus
    ? settings_sub_menu?.sub_menus?.find((item) => item?.name === "Teams")
        ?.permissions?.is_view
    : false;

  const handleTaskClick = (task) => {
    // if (!task?.disable) {
    navigate(task?.url);
    // }
  };

  // all transport provider filter [mahtab]
  const [couriersList, setCouriersList] = useState([]);
  // console.log('couriersList :' , couriersList)
  const [locationList, setLocationList] = useState([]);
  const [productList, setProductList] = useState([]);

  useEffect(() => {
    if (dispatch) {
      dispatch(fetchAllProducts(token));
    }
  }, [dispatch]);

  useEffect(() => {
    if (state) {
      if (state?.Products?.productList.length > 0) {
        setProductList([
          ...(state?.Products?.productList?.map((product) => ({
            id: product.id,
            name: product.name,
          })) || []),
        ]);
      }
    }
  }, [state]);

  useEffect(() => {
    getSettingsCouriersDDL(token).then((val) => {
      if (val && val.length > 0) {
        // console.log('couriers from settings : ' , val)
        const simplifiedCouriers = Array.from(
          new Map(
            val.map((courier) => [
              courier.courier_id,
              {
                id: courier.courier_id,
                courier_name: courier.courier_name,
              },
            ])
          ).values()
        );

        setCouriersList(simplifiedCouriers);
      }
    });

    // get transport providers from store [mahtab]
    // if (
    //   state?.Couriers?.courierList &&
    //   state?.Couriers?.courierList.length > 0
    // ) {
    //   let arr = state.Couriers.courierList.filter(
    //     (item) => item?.is_enabled === true
    //   );
    //   arr = arr.filter(
    //     (x) =>
    //       x.is_zoom_logi_provider ||
    //       x.is_public ||
    //       (!x.is_zoom_logi_provider && !x.is_public && x.status == "linked")
    //   );
    //   console.log('arr : ' , arr )
    //   setCouriersList(arr);
    // }

    getLocationDDL(token).then((val) => {
      if (val && val.length > 0) {
        setLocationList(val);
      }
    });
  }, []);

  const dateFilterModel = (val) => {
    if (
      val?.period !== "Custom" ||
      (val?.period === "Custom" && val?.end_date)
    ) {
      setVisibleDateFilter(false);
    }

    let period = val?.period;

    if (period === "Custom" || period === "All time") {
      period = null;
    }

    let formattedValue = filterDateFormatter(val);
    setInitialDateModal(val);
    setSelectedDateFilter(formattedValue);
    let start = val?.start_date
      ? dayjs(val.start_date).format("YYYY-MM-DD")
      : null;
    let end = val?.end_date ? dayjs(val.end_date).format("YYYY-MM-DD") : null;
    setFilterQuery({
      start_date: start,
      end_date: end,
      origins: [],
      destinations: [],
      products: [],
      teams: [],
      transporters: [],
      period: period,
      segment: timeRange,
    });
    // form.setFieldsValue({
    //   date:val
    // })
  };
  const filterDateFormatter = (val) => {
    if (!val || typeof val !== "object") return "No data";
    const period = val.period || "No Period";
    const start = val.start_date || "N/A";
    const end = val.end_date || "N/A";
    return `${period} (${start} - ${end})`;
  };

  const [calKey, setCalKey] = useState(0); // State to force re-render of the calendar
  // Function to handle input click
  const handleInputClick = () => {
    setCalKey((newKey) => newKey + 1);
    setVisibleDateFilter(!visibleDateFilter); // Show the dropdown on input click
  };

  // Function to handle key press (Enter key)
  const handleKeyPress = (e) => {
    if (e.key === "Enter") {
      setVisibleDateFilter(true); // Show the dropdown on Enter key press
    }
  };

  const DateFilterMenu = () => {
    return (
      <Menu
        className="date-filter-menu"
        style={{
          width: "auto",
          borderRadius: "12px",
          boxShadow: "0px 4px 16px 0px rgba(0, 0, 0, 0.27)",
          top: "5px",
          padding: "16px 8px",
          paddingTop: "0px",
        }}
      >
        <Menu.ItemGroup>
          <HomeDateFilter
            keys={calKey}
            handleDataFromChild={dateFilterModel}
            initialDateModal={initialDateModal}
          ></HomeDateFilter>
        </Menu.ItemGroup>
      </Menu>
    );
  };

  const onFormValueChanges = (e) => {
    setSelectedDate((prevState) => {
      if (e.transporters) {
        return { ...prevState, transporters: [e.transporters] };
      }
      if (e.locations) {
        return { ...prevState, locations: [e.locations] };
      }
      return prevState;
    });
  };

  const [allTeams, setAllTeams] = useState([]);

  useEffect(() => {
    getTeamsDDLOFFeature(token, "Users").then((val) => {
      if (val && val.length > 0) {
        setAllTeams(val);
      }
    });
  }, []);

  const menu = (
    <Menu
      style={{
        width: "250px",
        borderRadius: "12px",
        boxShadow: "0px 4px 16px 0px rgba(0, 0, 0, 0.27)",
        top: "5px",
        paddingTop: "8px",
        paddingBottom: "8px",
      }}
    >
      <div
        style={{
          maxHeight: "500px",
          overflowY: "auto",
          paddingBottom: "8px",
        }}
      >
        <Menu.ItemGroup>
          {allTeams.map((option) => (
            <Menu.Item key={option.id} style={{ padding: "4px 10px" }}>
              <Checkbox
                style={{ fontSize: "12px" }}
                className="custom-menu-shipment-checkbox"
              >
                
                {option?.title || option?.name || option?.courier_name}
              </Checkbox>
            </Menu.Item>
          ))}
        </Menu.ItemGroup>
      </div>
      <Flex
        style={{
          position: "sticky",
          bottom: "0",
          padding: "8px 4px 0",
        }}
        justify="flex-end"
      >
        <CustomButton
          text="Apply"
          width={62}
          height={32}
          bgColor="#000"
          color="#fff"
          fontSize={12}
          fontWeight={500}
          borderRadius={8}
          boxShadow="0px 4px 16px 0px rgba(0, 0, 0, 0.27)"
        />
      </Flex>
    </Menu>
  );

  // const handleDataApply = (ids) => console.log("Selected teams:", ids);

  const handleTeamApply = (ids) => {
    setFilterQuery((prev) => ({ ...prev, teams: ids }));
  };

  const handleCouriersApply = (ids) => {
    setFilterQuery((prev) => ({ ...prev, transporters: ids }));
  };

  const handleProductApply = (ids) => {
    setFilterQuery((prev) => ({ ...prev, products: ids }));
  };

  const handleOriginsApply = (ids) => {
    setFilterQuery((prev) => ({ ...prev, origins: ids }));
  };

  const handleDestinationApply = (ids) => {
    setFilterQuery((prev) => ({ ...prev, destinations: ids }));
  };
  
  const handleSegmentApply = (value) => {
    setFilterQuery((prev) => ({ ...prev, segment: value }));
    setTimeRange(value)
  };

  const handleTabChange = (type, newStatus) => {
    if (type==='shipments') {
      setFilterQuery((prev) => ({ ...prev, chart_type: newStatus.toLowerCase() }));
    } else {
      setFilterQuery((prev) => ({ ...prev, transit_time_filter: newStatus.toLowerCase() }));
    }
  };
  
  const handleRFTAlertsApply = (ids) => {
    setFilterQuery((prev) => ({ ...prev, rft_alerts: ids }));
  };
  const [isShipments, setIsShipments] = useState([]);
  const [loading, setLoading] = useState(true); // Add this line

  const fetchShipments = () => {
    setLoading(true);
    GetShipments(token)
      .then((res) => {
        const data = res?.data ? res.data : null;
        if (data?.data?.is_success) {
          const resp = data?.data?.data || [];
          setIsShipments(resp);
        }
      })
      .catch((error) => {
        unauthorize(error);
      })
      .finally(() => {
        setLoading(false); // Stop loading in all cases
      });
  };

  useEffect(() => {
    fetchShipments();
  }, []);

  return (
    <>
      <Flex gap={24} vertical={true}>
        {/* <CustomTitle
          text={moment(Date()).format("dddd, MMMM DD")}
          color={"#000"}
          fontSize={24}
          fontWeight={700}
          lineHeight={"32px"}
          marginBottom={0}
        /> */}
        {/* News flash card  */}
        <NewsFlash />

        {/* task and map row  */}
        <Row gutter={[24, 16]}>
          {settings_sub_menu && (
            <>
              {/* {!allTaskTrue && ( */}
              <Col xxl={6} xl={7} lg={10} md={24} sm={24}>
                <Card
                  style={{
                    width: "100%",
                    borderRadius: "12px",
                    border: "2px solid #EEE",
                    padding: "0",
                    height: "100%",
                  }}
                  bodyStyle={{ padding: "16px 0" }}
                >
                  <div style={{ padding: "0 16px" }}>
                    <CustomTitle
                      text="Tasks"
                      fontSize={20}
                      fontWeight={700}
                      lineHeight={"28px"}
                      marginBottom={0}
                    />
                  </div>
                  <List
                    itemLayout="horizontal"
                    dataSource={tasksData}
                    renderItem={(task, index) => {
                      if (!task.is_view) return null;
                      return (
                        <List.Item
                          style={{
                            padding: "0 0 0 20px",
                            border: "0px",
                            cursor: "pointer",
                            gap: 20,
                          }}
                          // onClick={() => handleItemClick(index)}
                        >
                          <span
                            className={`tasks-custom-checkbox ${
                              task.checked ? "active" : ""
                            }`}
                          >
                            <Checkbox
                              // onClick={(e) => e.stopPropagation()}
                              checked={task.checked}
                            />
                            {task.checked ? (
                              <span className="active-icon">
                                <CheckOutlined style={{ color: "#fff" }} />
                              </span>
                            ) : null}
                          </span>
                          {/* <div 
                      style={{ alignItems: "center", display: "flex" }}
                    > */}
                          <div
                            onClick={() => handleTaskClick(task)}
                            style={{
                              flex: 1,
                              display: "flex",
                              gap: 20,
                              borderBottom:
                                tasksData.length === index + 1
                                  ? "0px"
                                  : "1px solid #f0f0f0",
                              padding: "14px 16px 14px 0px",
                            }}
                          >
                            <div style={{ flex: 1 }}>
                              <CustomTitle
                                text={task.title}
                                fontSize={12}
                                fontWeight={600}
                                lineHeight={"20px"}
                              />
                              <CustomParagraph
                                text={task.description}
                                fontSize={12}
                                fontWeight={400}
                                lineHeight={"20px"}
                                marginBottom={0}
                                color={"#5E5E5E"}
                                whiteSpace="break-spaces"
                              />
                            </div>
                            {/* {
                        task.checked ? null : <img src={ChevronRightGray} alt="" />
                      } */}
                            {/* {task.disable === false && ( */}
                            <img src={ChevronRightGray} alt="" />
                            {/* )} */}
                          </div>
                          {/* </div> */}
                        </List.Item>
                      );
                    }}
                  />
                </Card>
              </Col>
              {/* )} */}
            </>
          )}

          <Col
            // xxl={settings_sub_menu ? (!allTaskTrue ? 18 : 24) : 24}
            // xl={settings_sub_menu ? (!allTaskTrue ? 17 : 24) : 24}
            // lg={settings_sub_menu ? (!allTaskTrue ? 14 : 24) : 24}
            xxl={settings_sub_menu ? 18 : 24}
            xl={settings_sub_menu ? 17 : 24}
            lg={settings_sub_menu ? 14 : 24}
            md={24}
            sm={24}
            style={{ height: "inherit", width: "100%" }}
          >
            <Card
              style={{
                width: "100%",
                borderRadius: "12px",
                border: "0",
                padding: "0",
                overflow: "hidden",
                height: "100%",
                minHeight: "500px",
              }}
              bodyStyle={{ padding: "0", height: "100%" }}
            >
              <GoogleMapsProvider>
                <HomeGoolgeMap isShipments={isShipments} loading={loading} allTeams={allTeams} hasValidTeams={hasValidTeams} teamsPermissions={teamsPermissions} />
              </GoogleMapsProvider>
              {/* <OsmMap position={position} /> */}
            </Card>
          </Col>
        </Row>
        {/* filters row  */}
        <Row gutter={[24, 16]}>
          <Col span={24}>
            <Flex wrap justify="space-between" align="center" gap={20}>
              <CustomParagraph
                text="My KPIs"
                fontSize={20}
                lineHeight="28px"
                fontWeight={700}
                marginBottom={0}
              />
              <Form
                form={form}
                autoComplete="off"
                onValuesChange={onFormValueChanges}
              >
                <Flex wrap gap={8} align="center">
                  <div className="custom-select-wrapper">
                    <Form.Item className="custom-input" name="date">
                      <Dropdown
                        className="home-date-filter-dropdown"
                        overlay={DateFilterMenu}
                        visible={visibleDateFilter}
                        onVisibleChange={(visible) =>
                          setVisibleDateFilter(visible)
                        }
                        trigger={["click"]}
                      >
                        <div onClick={handleInputClick}>
                          <Input
                            className={`home-date-filter-dropdown-width ${
                              visibleDateFilter
                                ? "input-home-date-open"
                                : "input-home-date"
                            }  `}
                            readOnly
                            value={selectedDateFilter}
                            style={{
                              fontWeight: 700,
                              fontSize: "12px",
                              height: "28px",
                              border: "0px",
                              backgroundColor: visibleDateFilter
                                ? "#000"
                                : "#F3F3F3",
                              color: "red",
                              borderRadius: "8px",
                              cursor: "pointer",
                            }}
                            placeholder="Click or press Enter to open dropdown"
                            onKeyDown={handleKeyPress}
                            suffix={
                              <svg
                                width="12"
                                height="12"
                                viewBox="0 0 12 12"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  d="M8.295 4.14763L6 6.43763L3.705 4.14763L3 4.85263L6 7.85263L9 4.85263L8.295 4.14763Z"
                                  fill={visibleDateFilter ? "white" : "black"}
                                />
                              </svg>
                            }
                          />
                        </div>
                      </Dropdown>
                    </Form.Item>
                  </div>
                  {/* <DatePicker
                    onChange={handleDateChange}
                    format="YYYY-MM-DD"
                    placeholder="Select Date"
                    defaultValue={dayjs("2025-01-01")}
                    style={{
                      width: "128px",
                      height: "36px",
                      borderRadius: "40px",
                      backgroundColor: "#F3F3F3",
                      border: "none",
                      boxShadow: "none",
                    }}
                  /> */}
                  {/* 
                  {couriersPermissions && (
                    <div className="custom-select-wrapper">
                      <Form.Item className="custom-input" name="transporters">
                        <CustomDynamicSelect
                          placeholder="Select"
                          height="36px"
                          width={"151px"}
                          border="0px"
                          bgColor="#F3F3F3"
                          textColor="#5E5E5E"
                          borderRadius="8px"
                          label={"courier_name"}
                          options={couriersList}
                          // label="title"
                          allowClear={true}
                        />
                      </Form.Item>
                    </div>
                  )} */}

                  {couriersPermissions && (
                    <HomeFilterDropdown
                      title="All transport providers"
                      options={couriersList}
                      onApply={handleCouriersApply}
                    />
                  )}
                  {locationPermissions && (
                    <>
                      <HomeFilterDropdown
                        title="All origins"
                        options={locationList}
                        onApply={handleOriginsApply}
                      />

                      <HomeFilterDropdown
                        title="All destinations"
                        options={locationList}
                        onApply={handleDestinationApply}
                      />
                    </>
                  )}

                  {productsPermissions && (
                    <HomeFilterDropdown
                      title="All Products"
                      options={productList}
                      onApply={handleProductApply}
                    />
                  )}
                  {hasValidTeams && teamsPermissions ? (
                    <HomeFilterDropdown
                      title="All Teams"
                      options={allTeams}
                      onApply={handleTeamApply}
                    />
                  ) : null}

{/* segment by filter */}

                   <div
                    className="custom-vertical-divider"
                    style={{ margin: "0 12px" }}
                  ></div>
                  <Flex gap={8} align="center" className="segment-by-style">
                    <CustomParagraph
                      text={"Segment by"}
                      fontWeight={400}
                      fontSize={12}
                      lineHeight={"20px"}
                      color="#5e5e5e"
                      marginBottom={0}
                      whiteSpace={"nowrap"}
                    />

                    <Select
                      value={timeRange}
                      onChange={(value) => handleSegmentApply(value)}
                      options={[
                        { label: "Week", value: "week" },
                        { label: "Month", value: "month" },
                      ]}
                      style={{
                        width: 85,
                        backgroundColor: "#f3f3f3",
                        fontWeight: "bold",
                        fontSize: "12px",
                        borderRadius: "8px",
                        height: "28px",
                      }}
                      dropdownStyle={{ borderRadius: 8 }}
                    />
                  </Flex>

                  {/* {locationPermissions && (
                    <div className="custom-select-wrapper">
                      <Form.Item className="custom-input" name="locations">
                        <CustomDynamicSelect
                          placeholder="Select"
                          width="151px"
                          height="36px"
                          border="0px"
                          bgColor="#F3F3F3"
                          textColor="#5E5E5E"
                          borderRadius="8px"
                          options={locationList}
                          allowClear={true}
                        />
                      </Form.Item>
                    </div>
                  )} */}
                </Flex>
              </Form>
            </Flex>
          </Col>
        </Row>
        {/* card row  */}
        <Row gutter={[24, 16]}>
          <Col xxl={4} xl={6} lg={8} md={12} sm={24} style={{ width: "100%" }}>
            <AnalyticsCard>
              <AnalyticsData
                title={"Shipments"}
                data={shipmentChart ? shipmentChart : {}}
                value={
                  shipmentChart?.total_count
                    ? shipmentChart?.total_count
                    : "---"
                }
                change={shipmentChart?.variance ?? "---"}
                fromDate={shipmentChart?.variance_time_period}
                isPositive={true}
                setModalOpen={setModalOpen}
                setSelectedMetricData={setSelectedMetricData}
                isShipments={isShipments}
              />
            </AnalyticsCard>
          </Col>
          {/* on time delivery */}
          <Col xxl={4} xl={6} lg={8} md={12} sm={24} style={{ width: "100%" }}>
            <AnalyticsCard>
              <AnalyticsData
                title={"On-time delivery (OTD)"}
                data={ontimeChart ? ontimeChart : {}}
                value={
                  ontimeChart?.total_count
                    ? ontimeChart?.total_count + "%"
                    : "---"
                }
                change={ontimeChart?.variance ?? "---"}
                fromDate={ontimeChart?.variance_time_period}
                isPositive={true}
                setModalOpen={setModalOpen}
                setSelectedMetricData={setSelectedMetricData}
                isShipments={isShipments}
              />
            </AnalyticsCard>
          </Col>

          {/* median transit time  */}
          <Col xxl={4} xl={6} lg={8} md={12} sm={24} style={{ width: "100%" }}>
            <AnalyticsCard>
              <AnalyticsData
                title={"Median transit time"}
                data={averagetimeChart ? averagetimeChart : {}}
                value={`${
                  averagetimeChart?.overall_average_transit_time
                    ? averagetimeChart?.overall_average_transit_time + " hr"
                    : "---"
                } `}
                change={averagetimeChart?.variance ?? "---"}
                fromDate={averagetimeChart?.variance_time_period}
                isPositive={true}
                setModalOpen={setModalOpen}
                setSelectedMetricData={setSelectedMetricData}
                isShipments={isShipments}
              />
            </AnalyticsCard>
          </Col>
          {/* right first time card  */}
          <Col xxl={4} xl={6} lg={8} md={12} sm={24} style={{ width: "100%" }}>
            <AnalyticsCard>
              <AnalyticsData
                title="Right first time"
                data={rightTimeChart ? rightTimeChart : {}}
                value={`${
                  rightTimeChart?.average_rft
                    ? rightTimeChart?.average_rft + "%"
                    : "---"
                }`}
                change={rightTimeChart?.variance ?? "---"}
                fromDate={rightTimeChart?.variance_time_period}
                isPositive={false}
                setModalOpen={setModalOpen}
                setSelectedMetricData={setSelectedMetricData}
                isShipments={isShipments}
              />
            </AnalyticsCard>
          </Col>
        </Row>
        {/* first 2 charts  */}
        <Row gutter={[24, 16]} className="home-charts">
          {/* shipments charts  */}
          <Col
            xxl={12}
            xl={12}
            lg={12}
            md={24}
            sm={24}
            style={{ width: "100%" }}
          >
            <Card
              style={{
                width: "100%",
                borderRadius: "12px",
                border: "2px solid #EEE",
                padding: "0",
              }}
              className="single-card"
              bodyStyle={{
                padding: "16px",
                width: "100%",
              }}
            >
              <Flex
                className="home-charts"
                vertical={true}
                gap={16}
                style={{ width: "100%" }}
              >
                <div>
                  {/* <AnalyticsData
                    title={"Shipments"}
                    data={shipmentChart ? shipmentChart : {}}
                    value={
                      shipmentChart?.total_count
                        ? shipmentChart?.total_count
                        : "---"
                    }
                    change={shipmentChart?.variance ?? "---"}
                    fromDate={shipmentChart?.variance_time_period}
                    isPositive={true}
                    setModalOpen={setModalOpen}
                    setSelectedMetricData={setSelectedMetricData}
                    isShipments={isShipments}
                  /> */}
                  <AnalyticsChartData
                    title={"Shipments"}
                    data={shipmentChart ? shipmentChart : {}}
                    value={
                      shipmentChart?.total_count
                        ? shipmentChart?.total_count
                        : "---"
                    }
                    change={shipmentChart?.variance ?? "---"}
                    // fromDate={shipmentChart?.variance_time_period}
                    fromDate={'change from previous period'}
                    isPositive={true}
                    setModalOpen={setModalOpen}
                    setSelectedMetricData={setSelectedMetricData}
                    isShipments={isShipments}
                    handleTabChange={handleTabChange}
                  />
                </div>

                <ReactApexChart
                  options={{
                    ...shipment.options,
                    chart: {
                      ...shipment.options.chart,
                      width: "100%",
                    },
                  }}
                  series={shipment.series}
                  type="bar"
                  height={190}
                />
              </Flex>
            </Card>
          </Col>

          {/* on time delivery  */}

          <Col
            xxl={12}
            xl={12}
            lg={12}
            md={24}
            sm={24}
            style={{ width: "100%" }}
          >
            <Card
              style={{
                width: "100%",
                borderRadius: "12px",
                border: "2px solid #EEE",
                padding: "0",
              }}
              className="single-card"
              bodyStyle={{
                padding: "16px",
                width: "100%",
              }}
            >
              <Flex
                className="home-charts"
                vertical={true}
                gap={16}
                style={{ width: "100%" }}
              >
                <div>
                  {/* <AnalyticsData
                    title={"On-time delivery (OTD)"}
                    data={ontimeChart ? ontimeChart : {}}
                    value={
                      ontimeChart?.total_count
                        ? ontimeChart?.total_count + "%"
                        : "---"
                    }
                    change={ontimeChart?.variance ?? "---"}
                    fromDate={ontimeChart?.variance_time_period}
                    isPositive={true}
                    setModalOpen={setModalOpen}
                    setSelectedMetricData={setSelectedMetricData}
                    isShipments={isShipments}
                  /> */}
                  <AnalyticsChartData
                    title={"On-time delivery (OTD)"}
                    data={ontimeChart ? ontimeChart : {}}
                    value={
                      ontimeChart?.total_count
                        ? ontimeChart?.total_count + "%"
                        : "---"
                    }
                    change={ontimeChart?.variance ?? "---"}
                    // fromDate={ontimeChart?.variance_time_period}
                    fromDate={'change from previous period'}
                    isPositive={true}
                    setModalOpen={setModalOpen}
                    setSelectedMetricData={setSelectedMetricData}
                    isShipments={isShipments}
                    setOpenBufferModal={setOpenBufferModal}
                  />
                  
                </div>

                <ReactApexChart
                  options={{
                    ...onTimeDelivery.options,
                    chart: {
                      ...onTimeDelivery.options.chart,
                      width: "100%",
                    },
                  }}
                  series={onTimeDelivery.series}
                  type="bar"
                  height={190}
                />
              </Flex>
            </Card>
          </Col>

          {/* <Col
            xxl={12}
            xl={12}
            lg={12}
            md={24}
            sm={24}
            style={{ width: "100%" }}
          >
            <Card
              style={{
                width: "100%",
                borderRadius: "12px",
                border: "2px solid #EEE",
                padding: "0",
              }}
              className="single-card"
              bodyStyle={{
                padding: "16px",
                width: "100%",
              }}
            >
              <Flex vertical={true} gap={16} style={{ width: "100%" }}>
                <div>
                  <AnalyticsData
                    title={"On-time delivery (OTD)"}
                    data={ontimeChart ? ontimeChart : {}}
                    value={
                      ontimeChart?.total_count
                        ? ontimeChart?.total_count + "%"
                        : "---"
                    }
                    change={ontimeChart?.variance ?? '---'}
                    fromDate={ontimeChart?.variance_time_period}
                    isPositive={true}
                    setModalOpen={setModalOpen}
                    setSelectedMetricData={setSelectedMetricData}
                    isShipments={isShipments}
                  />
                </div>

                <ReactApexChart
                  options={{
                    ...onTimeDelivery.options,
                    chart: {
                      ...onTimeDelivery.options.chart,
                      width: "100%",
                    },
                  }}
                  series={onTimeDelivery.series}
                  type="line"
                  height={350}
                />
              </Flex>
            </Card>
          </Col> */}
        </Row>
        {/* second 2 charts  */}

        <Row gutter={[24, 16]} wrap justify="start" className="home-charts">
          {/* Median transit time  */}

          <Col
            xxl={12}
            xl={12}
            lg={12}
            md={24}
            sm={24}
            style={{ width: "100%" }}
          >
            <Card
              style={{
                width: "100%",
                borderRadius: "12px",
                border: "2px solid #EEE",
                padding: "0",
              }}
              className="single-card"
              bodyStyle={{
                padding: "16px",
                width: "100%",
              }}
            >
              <Flex
                className="home-charts"
                vertical={true}
                gap={16}
                style={{ width: "100%" }}
              >
                <div>
                  {/* <AnalyticsData
                    title={"Median transit time"}
                    data={averagetimeChart ? averagetimeChart : {}}
                    value={`${
                      averagetimeChart?.overall_average_transit_time
                        ? averagetimeChart?.overall_average_transit_time + " hr"
                        : "---"
                    }`}
                    change={averagetimeChart?.variance ?? "---"}
                    fromDate={averagetimeChart?.variance_time_period}
                    isPositive={true}
                    setModalOpen={setModalOpen}
                    setSelectedMetricData={setSelectedMetricData}
                    isShipments={isShipments}
                  /> */}
                  <AnalyticsChartData
                    title={"Transit time"}
                    data={averagetimeChart ? averagetimeChart : {}}
                    value={`${
                      averagetimeChart?.overall_average_transit_time
                        ? averagetimeChart?.overall_average_transit_time + " hr"
                        : "---"
                    }`}
                    change={averagetimeChart?.variance ?? "---"}
                    // fromDate={averagetimeChart?.variance_time_period}
                    fromDate={'change from previous period'}
                    isPositive={true}
                    setModalOpen={setModalOpen}
                    setSelectedMetricData={setSelectedMetricData}
                    isShipments={isShipments}
                    handleTabChange={handleTabChange}
                  />
                </div>

                <ReactApexChart
                  options={{
                    ...avgTransitTime.options,
                    chart: {
                      ...avgTransitTime.options.chart,
                      width: "100%",
                    },
                  }}
                  series={avgTransitTime.series}
                  type="bar"
                  height={190}
                />
              </Flex>
            </Card>
          </Col>
          {/* right first time  chart */}

          <Col
            xxl={12}
            xl={12}
            lg={12}
            md={24}
            sm={24}
            style={{ width: "100%" }}
          >
            <Card
              style={{
                width: "100%",
                borderRadius: "12px",
                border: "2px solid #EEE",
                padding: "0",
              }}
              className="single-card"
              bodyStyle={{
                padding: "16px",
                width: "100%",
              }}
            >
              <Flex
                className="home-charts"
                vertical={true}
                gap={16}
                style={{ width: "100%" }}
              >
                <div>
                  {/* <AnalyticsData
                    title={"Right first time"}
                    data={rightTimeChart ? rightTimeChart : {}}
                    value={`${
                      rightTimeChart?.average_rft
                        ? rightTimeChart?.average_rft + "%"
                        : "---"
                    }`}
                    change={rightTimeChart?.variance ?? "---"}
                    fromDate={rightTimeChart?.variance_time_period}
                    isPositive={false}
                    setModalOpen={setModalOpen}
                    setSelectedMetricData={setSelectedMetricData}
                    isShipments={isShipments}
                  /> */}
                  <AnalyticsChartData
                    title={"Right first-time (RFT)"}
                    data={rightTimeChart ? rightTimeChart : {}}
                    value={`${
                      rightTimeChart?.average_rft
                        ? rightTimeChart?.average_rft + "%"
                        : "---"
                    }`}
                    change={rightTimeChart?.variance ?? "---"}
                    // fromDate={rightTimeChart?.variance_time_period}
                    fromDate={'change from previous period'}
                    isPositive={false}
                    setModalOpen={setModalOpen}
                    setSelectedMetricData={setSelectedMetricData}
                    isShipments={isShipments}
                    handleRFTAlertsApply={handleRFTAlertsApply}
                  />
                </div>

                <ReactApexChart
                  options={{
                    ...atRiskAlerts.options,
                    chart: {
                      ...atRiskAlerts.options.chart,
                      width: "100%",
                    },
                  }}
                  series={atRiskAlerts.series}
                  type="bar"
                  height={190}
                />
              </Flex>
            </Card>
          </Col>

          {/* <Col
            xxl={12}
            xl={12}
            lg={12}
            md={24}
            sm={24}
            style={{ width: "100%" }}
          >
            <Card
              style={{
                width: "100%",
                borderRadius: "12px",
                border: "2px solid #EEE",
                padding: "0",
              }}
              className="single-card"
              bodyStyle={{
                padding: "16px",
              }}
            >
              <Flex vertical={true} gap={16} style={{ width: "100%" }}>
                <div>
                  <AnalyticsData
                    title={"Right first time"}
                    data={rightTimeChart ? rightTimeChart : {}}
                    value={`${
                      rightTimeChart?.average_rft
                        ? rightTimeChart?.average_rft + "%"
                        : "---"
                    }`}
                    change={rightTimeChart?.variance ?? '---'}
                    fromDate={rightTimeChart?.variance_time_period}
                    isPositive={false}
                    setModalOpen={setModalOpen}
                    setSelectedMetricData={setSelectedMetricData}
                    isShipments={isShipments}
                  />
                </div>

                <ReactApexChart
                  options={{
                    ...atRiskAlerts.options,
                    chart: {
                      ...atRiskAlerts.options.chart,
                      width: "100%",
                    },
                  }}
                  series={atRiskAlerts.series}
                  type="line"
                  height={350}
                />
              </Flex>
            </Card>
          </Col> */}
        </Row>
      </Flex>

      {modalOpen && (
        <CustomModalWithoutButton
          modalOpen={modalOpen}
          setModalOpen={setModalOpen}
          modalTitle={`Set metric target`}
          fontSize={"20px"}
          lineHeight="28px"
          modalText="Specify a target to compare your metric against (optional)"
          modalTextFontSize={"12px"}
          modalSize={447}
          modalBorderRadius={"16px"}
        >
          <MetricsForm
            closeModal={closeModal}
            onSuccess={onScuccessTarget}
            selectedMetircData={selectedMetircData}
          />
        </CustomModalWithoutButton>
      )}

      {openBufferModal && (
        <CustomModalWithoutButton
          modalOpen={openBufferModal}
          setModalOpen={setOpenBufferModal}
          modalTitle={`Modify buffer`}
          fontSize={"20px"}
          lineHeight="28px"
          modalText="Change buffer that qualifies an On-time delivery"
          modalTextFontSize={"12px"}
          modalSize={447}
          modalBorderRadius={"16px"}
        >
          <ModifyBuffer
            closeModal={closeBufferModal}
            onSuccess={onScuccessSetBuffer}
            selectedMetircData={selectedMetircData}
          />
        </CustomModalWithoutButton>
      )}
    </>
  );
}

export default Home;
